import { z } from "zod";

import { northAmericanPhoneNumberSchema } from "@/shared/utils/phone-utils";

export const replyFaxRoutingOutputSchema = z.object({
  outcome: z.literal("ready"),
  // Older persisted stages recover this from the routing step's timestamp.
  requestedAt: z.string().datetime({ offset: true }).optional(),
  requestHash: z.string().regex(/^[a-f0-9]{64}$/),
  reason: z.string().min(1),
  targetFaxNumber: northAmericanPhoneNumberSchema,
  senderFaxNumber: northAmericanPhoneNumberSchema,
});

export const replyFaxPdfOutputSchema = replyFaxRoutingOutputSchema.extend({
  pathToFile: z.string().min(1),
  pageCount: z.number().int().positive(),
  pdfHash: z.string().regex(/^[a-f0-9]{64}$/),
});

export type ReplyFaxRoutingOutput = z.infer<typeof replyFaxRoutingOutputSchema> | { outcome: "skipped" };
export type ReplyFaxPdfOutput = z.infer<typeof replyFaxPdfOutputSchema> | { outcome: "skipped" };
